import { Plus } from 'lucide-react';
import type { Session } from '@/types';
import { SessionCard } from './SessionCard';

interface WaitListProps {
  sessions: Session[];
  onNotify: (session: Session) => void;
  onSeat: (session: Session) => void;
  onCancel: (session: Session) => void;
  onNewClient?: () => void;
}

export function WaitList({ sessions, onNotify, onSeat, onCancel, onNewClient }: WaitListProps) {
  const sorted = [...sessions].sort(
    (a, b) => new Date(a.arrived_at).getTime() - new Date(b.arrived_at).getTime()
  );

  const waitingCount = sorted.filter((s) => s.status === 'waiting').length;

  return (
    <div className="flex flex-col gap-4 w-full animate-fade-in">
      <div className="flex items-center justify-between px-1">
        <h2 className="text-sm font-bold uppercase tracking-widest" style={{ color: 'var(--qr-text-secondary)' }}>
          En espera ({waitingCount})
        </h2>
        {onNewClient && (
          <button
            onClick={onNewClient}
            className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-semibold transition-transform duration-200 active:scale-[0.96]"
            style={{ background: 'var(--qr-surface)', border: '1px solid var(--qr-border)', color: 'var(--qr-text)' }}
          >
            <Plus size={16} />
            Nuevo cliente manual
          </button>
        )}
      </div>

      {sorted.length === 0 ? (
        <div
          className="flex flex-col items-center justify-center gap-2 py-12 rounded-xl"
          style={{ background: 'var(--qr-surface)', border: '1px solid var(--qr-border)' }}
        >
          <p className="text-lg font-medium" style={{ color: 'var(--qr-text-secondary)' }}>
            No hay clientes en espera
          </p>
          <p className="text-sm" style={{ color: 'var(--qr-text-secondary)' }}>
            Escanea un QR o añade un cliente manualmente
          </p>
        </div>
      ) : (
        <div className="flex flex-col gap-3">
          {sorted.map((session) => (
            <SessionCard
              key={session.id}
              session={session}
              onNotify={() => onNotify(session)}
              onSeat={() => onSeat(session)}
              onCancel={() => onCancel(session)}
            />
          ))}
        </div>
      )}
    </div>
  );
}
